// extracted by mini-css-extract-plugin
module.exports = {"firstSlide":"_32U3gh","title":"CSSg-A","content":"_2oAHQy","note":"_2g7_2M","desktopWelcome":"_2iI68B"};